import { render, staticRenderFns } from "./FareDetails.vue?vue&type=template&id=f83cd082"
import script from "./FareDetails.vue?vue&type=script&lang=ts"
export * from "./FareDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports